import { createAction, props, union } from '@ngrx/store';
import { MafLtcSaveQueryI } from 'src/app/api/maf-ltc-save/maf-ltc-save-query.int';
import { MafLtcSaveResponseI } from 'src/app/api/maf-ltc-save/maf-ltc-save-result.int';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
/* eslint-disable max-len */

export const error = createAction('[LTC / Save] Error', props<{
  messageText: string;
  pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[LTC / Save] Reset', props<{
  pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[LTC / Save] Load', props<{
  query: MafLtcSaveQueryI;
  pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[LTC / Save] Received', props<{
  data: MafLtcSaveResponseI;
  pageType: SharedPageTypeEnum;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
